exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-a9b6a49e] .el-dialog__body{max-height:580px;overflow:auto}[data-v-a9b6a49e] .is-fullscreen{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}[data-v-a9b6a49e] .is-fullscreen .el-dialog__body{-webkit-box-flex:1;-ms-flex:1;flex:1;max-height:100% !important}.operate-btn[data-v-a9b6a49e]{margin:2px}\n", ""]);

// exports
